export class Address {
  city: string;
  stateProvince: string;
  country: string;
}
